module.exports = __webpack_public_path__ + "static/media/setup.25d56e43.png";